<template>
  <b-col class="pb-4">
    <b-table
      v-if="items.length > 0"
      v-on:row-clicked="clickedEmit($event)"
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      :items="items"
      :fields="captions"
      :current-page="currentPage"
      :per-page="perPage"
      class="table-show-recursos"
    >
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="file" slot-scope="data">
        <img
          v-if="data.item.type == 'IMAGEN'"
          class="img-preview"
          :src="$root.setUrlFile(data.item.file)"
        />
        <audio
          v-else-if="data.item.type == 'AUDIO'"
          class="audio-preview"
          modal-recurso
          controls
          autobuffer
        >
          <source :src="$root.setUrlFile(data.item.file)" />
        </audio>
        <video
          @click="toogleMute()"
          id="videoElement"
          v-else
          class="video-preview"
          controls
          :src="$root.setUrlFile(data.item.file)"
        >
          <source :src="$root.setUrlFile(data.item.file)" />
        </video>
      </template>
      <template slot="tags" slot-scope="data">
        <p style="font-size:1rem;">{{ joinArray(data.item.tags) }}</p>
      </template>
      <template slot="fechaUltimaActualizacion" slot-scope="data">
        <p>{{ data.item.fechaUltimaActualizacion | moment("DD/MM/YYYY") }}</p>
      </template>
      <template slot="actions" slot-scope="data">
        <button
          @click="btnClicked(button.id,data.item)"
          class="btn"
          v-for="button in buttons"
          :key="button.id"
          v-b-popover.hover.bottom="button.popover"
          v-if="(!(data.item.author._id == $parent.user._id && button.id == 'btn_unshare')) && (!(data.item.author._id != $parent.user._id && button.id == 'btn-remove'))"
        >
          <font-awesome-icon
            v-if="button.icon"
            :icon="button.icon"
            v-bind:class="[ data.item.compartido.includes($parent.user._id) && button.id == 'btn-share' ? 'fav' : '' ]"
          />
        </button>
        <b-checkbox
          v-if="(!(data.item.author._id != $parent.user._id))"
          :checked="data.item.isChecked"
          class="chk-btn"
          name="checkbox-recursos"
          @change="recursosSelected($event,data.item)"
        ></b-checkbox>
      </template>
    </b-table>
    <nav v-if="showPagination && items.length > 0">
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
        prev-text="Anterior"
        next-text="Siguiente"
        hide-goto-end-buttons
      />
    </nav>
    <h3 v-if="items.length == 0" style="text-align: center; margin-bottom:40px;">No Existen Recursos con el Filtro de Búsqueda</h3>
  </b-col>
</template>
<style lang="scss" scoped>
.modal-recurso {
  max-width: 300px !important;
}
.btn .icon-recursos {
  color: #73818f;

  &:hover {
    color: #23282c;
  }
}
.table-show-recursos {
  padding-bottom: 15px;
}
.video-preview,
.img-preview {
  width: 180px;
  border: 3px solid #eee;
}
</style>

<script>
export default {
  name: "cTable",
  inheritAttrs: false,
  props: {
    showPagination: {
      type: Boolean,
      default: true
    },
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default: () => {
        return [];
      }
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 9
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1
    };
  },
  created() {
    console.log(this.tableData);
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    recursosSelected: function(e, recurso) {
      console.log(recurso);
      var data = {
        checked: e,
        recurso: recurso
      };
      this.$emit("dataCheckedRecursos", data);
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    clickedEmit(e) {
      this.$emit("row-clicked", e);
    },
    toogleMute() {
      var video = document.getElementById("videoElement");

      if (video.muted) {
        video.muted = false;
      } else {
        video.muted = true;
      }
    },
    joinArray(array) {
      return array.join();
    },
    btnClicked: function(id, data) {
      if (id && data) {
        let emitter = {
          id: id,
          record: data
        };
        this.$emit("btnClicked", emitter);
      }
    }
  }
};
</script>